import http from "./httpService";

const endPoint = "/api/v1/Plants";

export function getAllPlants() {
    return http.get(`${endPoint}`);
}

export function addStorage(id, request) {
    return http.post(`${endPoint}/${id}/StorageLocation`, request);
}

export function getAllStorage(id) {
    return http.get(`${endPoint}/${id}/StorageLocation`);
}

export default { getAllPlants, addStorage, getAllStorage };


// WEBPACK FOOTER //
// ./src/services/PlantsService.js